import { render } from "./MoreInfo.vue?vue&type=template&id=51aa0e18&scoped=true"
import script from "./MoreInfo.vue?vue&type=script&lang=js"
export * from "./MoreInfo.vue?vue&type=script&lang=js"

import "./MoreInfo.vue?vue&type=style&index=0&id=51aa0e18&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51aa0e18"]])

export default __exports__